<template>
  <div id="main">
    <section id="content">
      <div class="container">
        <h1>Firmar archivos</h1>
        <div class="row">
          <div class="col s12 m8">
            <p>
              Total de Archivos sin Firmar:
              <strong>{{ files.length }}</strong>
            </p>
          </div>
          <div class="col s12 m4 right">
            <input
              type="text"
              class="search"
              placeholder="Buscar archivo..."
              v-model="fileToSearch"
              @keyup.enter="searchFiles()"
            />
          </div>
        </div>
        <table class="striped responsive-table">
          <thead>
            <tr>
              <td>Nombre</td>
              <td>Clasificación</td>
              <td>Tamaño</td>
              <td></td>
              <td></td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="file in searchFiles" :key="file.id">
              <td>
                <a class="adjunto">
                  <i class="material-icons left">insert_drive_file</i>
                  {{ file.name }}
                </a>
              </td>
              <td>{{ file.type }}</td>
              <td>{{ file.size }}</td>
              <td>
                <label>
                  <input type="checkbox" @click="markFilesToSign(file)" />
                  <span></span>
                </label>
              </td>
              <td>
                <label
                  @click="deleteFile(file)"
                  class="icon delete tooltipped"
                  data-position="left"
                  data-tooltip="Eliminar archivo"
                >
                  <i class="material-icons">delete</i>
                </label>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="row">
          <div class="col s12 m4 right">
            <p class="right">
              <button @click="signFiles()" class="btn waves-effect waves-light">
                <i class="material-icons left">playlist_add_check</i> Firmar
                archivos
              </button>
            </p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { helpersMixin } from "../mixins/helpers";

export default {
  name: "firmar",
  mixins: [helpersMixin],
  data() {
    return {
      filesToSign: [],
      fileToSearch: "",
      file: "",
      files: [],
      cert_pass: "",
    };
  },
  mounted() {
    this.getFilesToSign();
  },
  computed: {
    searchFiles() {
      return this.files.filter((file) => {
        return file.name
          .toLowerCase()
          .includes(this.fileToSearch.toLowerCase());
      });
    },
  },
  methods: {
    getFilesToSign() {
      let loader = this.$loading.show({
        container: this.fullPage,
        canCancel: false,
      });
      this.$store.dispatch("getFilesToSign").then((response) => {
        loader.hide();
        response.data.files.forEach((file, index) => {
          this.file = {
            id: index,
            name: file.name,
            hash: file.hash,
            type: file.type,
            size: helpersMixin.methods.formatBytes(file.size),
            uploadDate: file.uploadDate,
          };
          this.files.push(this.file);
        });
      });
    },
    markFilesToSign(file) {
      if (this.filesToSign.includes(file)) {
        this.filesToSign.splice(file, 1);
      } else {
        this.filesToSign.push(file);
      }
    },
    deleteFile(file) {
      this.$fire({
        title: "¿Está seguro que desea eliminar el archivo?",
        type: "warning",
        showCancelButton: true,
        cancelButtonText: "Cancelar",
        confirmButtonText: "Si, eliminar",
      }).then((res) => {
        if (res.value) {
          if (this.files.includes(file)) {
            this.files.splice(this.files.indexOf(file), 1);
          }
          this.$store
            .dispatch("deleteFile", {
              file: file,
              signed: false,
            })
            .then((response) => {
              if (response.data && response.data.status) {
                this.$fire({
                  title: "¡Archivo eliminado correctamente!",
                  type: "success",
                });
              }
            });
        }
      });
    },
    signFiles() {
      this.cert_pass = "";
      if (this.filesToSign.length) {
        this.$fire({
          title: "Contraseña de Certificado",
          type: "info",
          input: "password",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          inputValidator: (value) => {
            this.cert_pass = value;
            if (!value) {
              return "Debe ingresar la contraseña de su certificado digital para poder firmar!";
            }
            let loader = this.$loading.show({
              container: this.fullPage,
              canCancel: false,
            });
            this.$store
              .dispatch("signFiles", {
                files: this.filesToSign,
                cert_pass: btoa(this.cert_pass.toString()),
              })
              .then((response) => {
                loader.hide();
                let html = "";
                let allOk = true;
                if (response.data && response.data.status) {
                  response.data.files.forEach((item) => {
                    allOk = item.status == "FIRMADO" && allOk;
                    item.status = item.status.replace(
                      "FIRMADO",
                      "<p class='exito'><i class='material-icons'>done</i> El archivo se firmó exitosamente.</p>"
                    );
                    item.status = item.status.replace(
                      "NO FIRMADO",
                      " <p class='error'><i class='material-icons'>error</i> Hubo un error al firmar el archivo.</p>"
                    );
                    html +=
                      "<div>" +
                      item.name +
                      item.status +
                      (item.obs ? "<small>*" + item.obs + "</small>" : "") +
                      "</div>";
                  });
                  this.$fire({
                    title: "Detalle de la operación",
                    html: html,
                    type: allOk ? "success" : "warning",
                    showConfirmButton: true,
                  }).then((r) => {
                    if (r.value) {
                      this.$router.push({ name: "descargar" });
                    }
                  });
                } else {
                  this.$fire({
                    title: "Error en la operación",
                    html:
                      "<p>" +
                      (response.data && response.data.description
                        ? response.data.description
                        : "Error firmando algún archivo, por favor, contacte al administrador") +
                      "</p>",
                    type: "error",
                  });
                }
              })
              .catch((error) => {
                loader.hide();
                this.$fire({
                  title: "Hubo un error al intentar firmar uno de los archivos",
                  html: "<div>" + error + "</div>",
                  type: "error",
                });
              });
          },
        });
      } else {
        this.$fire({
          title: "Debe seleccionar al menos un archivo para firmar",
          type: "error",
        });
      }
    },
  },
};
</script>